export default "__VITE_ASSET__Bj2SEo9N__"